<h1>{{ 'TERMS_OF_SERVICE.TITLE' | translate }}</h1>
